import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
// import { map } from 'rxjs/operators';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { AssetLibraryConstants } from './constants/asset-library.constant';

@Injectable({
  providedIn: 'root'
})
export class BannerCarouselService {
  buttonName: string;
  userId = sessionStorage.getItem('userId');
  BANNER_CONTENTS_URL = AssetLibraryConstants.ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId + AssetLibraryConstants.BANNER_CONTENTS;
  GET_BANNER_CONTENTS_BY_ID_URL = this.BANNER_CONTENTS_URL + AssetLibraryConstants.SLASH;
  GET_BANNER_CONTENT_BY_PAGE_ID_URL = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId
    + AssetLibraryConstants.BANNER_CONTENTS + AssetLibraryConstants.SLASH;

  constructor(private httpMethodsservice: HttpMethodsService) {

  }

  createBannerContent(configurationsJson: string) {
    const url = this.BANNER_CONTENTS_URL;
    const addObject = {
      configurations: configurationsJson
    };

    return this.httpMethodsservice.post(url, addObject)
      .pipe(map((res: any) =>
        res));
  }

  putBannerContentById(inputJson: string, id: string) {
    const url = this.GET_BANNER_CONTENTS_BY_ID_URL + id;

    return this.httpMethodsservice.put(url, inputJson)
      .pipe(map((res: any) =>
        res));
  }

  getAllBannerContentByUser() {
    const url = this.BANNER_CONTENTS_URL;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getBannerContentById(id: string) {
    const url = this.GET_BANNER_CONTENTS_BY_ID_URL + id;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getBannerContentByPageId(bannerContentId: string, pageId: string) {
    const url = this.GET_BANNER_CONTENT_BY_PAGE_ID_URL
      + bannerContentId + AssetLibraryConstants.SLASH + pageId;

    return this.httpMethodsservice.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }

  getS3BannerContentById(bannerContentId: string) {
    const url = this.GET_BANNER_CONTENT_BY_PAGE_ID_URL + bannerContentId;

    return this.httpMethodsservice.getImage(url, true)
    .pipe(map((res: any) =>
      res));
  }

  putS3BannerContentByPageId(image: File, imageType: string, bannerContentId: string, pageId: string) {
    const url = this.GET_BANNER_CONTENT_BY_PAGE_ID_URL
      + bannerContentId + AssetLibraryConstants.SLASH + pageId;

    return this.httpMethodsservice.putImage(url, image, imageType, true)
      .pipe(map((res: any) =>
        res));
  }

  deleteS3BannerContentByPageId(bannerContentId: string, pageId: string) {
    const url = this.GET_BANNER_CONTENT_BY_PAGE_ID_URL
      + bannerContentId + AssetLibraryConstants.SLASH + pageId;

    return this.httpMethodsservice.delete(url, true)
      .pipe(map((res: any) =>
        res));
  }

  uploadImage(image: File, id: string, imageType: string) {
    const url = this.GET_BANNER_CONTENT_BY_PAGE_ID_URL + id;

    return this.httpMethodsservice.putImage(url, image, imageType, true)
      .pipe(map((res: any) =>
        res));
  }

  deleteBannerContentById(bannerContentId: string) {
    const url = this.BANNER_CONTENTS_URL
      + AssetLibraryConstants.SLASH + bannerContentId;

    return this.httpMethodsservice.delete(url)
      .pipe(map((res: any) =>
        res));
  }
}
